import { render, staticRenderFns } from "./DashboardStatisticChart.vue?vue&type=template&id=3718f268&scoped=true"
import script from "./DashboardStatisticChart.vue?vue&type=script&lang=js"
export * from "./DashboardStatisticChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3718f268",
  null
  
)

export default component.exports